import AuthGuardDisplay from '@components/AuthGuardDisplay';
import NumberBadge from '@components/Badge/NumberBadge';
import styled from '@emotion/styled';
import useCart from '@hooks/cart/useCart';
import CartLine from '@icons/CartLine';
import { Link } from '@stackflow/link';

interface Props {
    shopId: string;
}

function CartButton({ shopId }:Props) {
    const { cart } = useCart(shopId);
    const cartCount = cart?.items
        .reduce((acc, cur) => acc + cur.qty, 0) || 0;
    return (
        <AuthGuardDisplay>
            <Link activityName="CartActivity"
                activityParams={{ shopId }}>
                <Container>
                    <CartLine />
                    {(cartCount !== 0) && (
                        <Count>
                            {cartCount}
                        </Count>
                    )}
                </Container>
            </Link>
        </AuthGuardDisplay>
    );
}

const Container = styled.div`
    position: relative;
`;

const Count = styled(NumberBadge)`
    position: absolute;
    top: 2px;
    right: -4px;
`;

export default CartButton;
